// contexts/LogContext.js
import { createContext, useMemo, useReducer } from "react";
import {
  logHandlers,
  logInitialState,
  logReducer,
} from "../reducers/LogReducer";
import { useRenders } from "./useHelpers/useRenders";

export const _showAppLogs = {
  appInfo: false,
  appProfiles: false,
  baseSettings: false,
  cache: false,
  clientInfo: false,
  dataDocuments: false,
  dbFetch: false,
  eventDataValidation: false,
  eventInfo: false,
  firestore: false,
  fsCalls: false,
  itemData: false,
  logReducer: false,
  manifest: false,
  pageInfo: false,
  reducerTypes: false,
  regInfo: false,
  settings: false,
  sportInfo: true,
  sportsDistricts: false,
  sportsOrganizations: false,
  sportsSeason: true,
  storageInfo: false,
  timestamps: false,
  token: false,
  useSportResults: false,
  useSportsInfo: false,
  viewSettings: false,
}

export const LogContext = createContext();

const LogProvider = (props) => {

  const init_state = {};

  const [log_state, log_dispatch] = useReducer(
    logReducer,
    init_state,
    logInitialState
  );

  useRenders('Log Provider', true)

  const log_handlers = useMemo(() => logHandlers(log_dispatch), [log_dispatch]);

  return (
    <LogContext.Provider value={{ log_state, log_handlers }}>
      {props.children}
    </LogContext.Provider>
  );
};

export default LogProvider;
